export const UPDATE_BOOKING_EXPERIENCE_CONTACT_START = 'UPDATE_BOOKING_EXPERIENCE_CONTACT_START';

export const UPDATE_BOOKING_EXPERIENCE_CONTACT_SUCCESS = 'UPDATE_BOOKING_EXPERIENCE_CONTACT_SUCCESS';

export const UPDATE_BOOKING_EXPERIENCE_CONTACT_FAILURE = 'UPDATE_BOOKING_EXPERIENCE_CONTACT_FAILURE';
